// extracted by mini-css-extract-plugin
module.exports = {"container":"clinical-portal-3__VoiceCall__container","header":"clinical-portal-3__VoiceCall__header"};